export default "__VITE_ASSET__BXSXyM7d__"